import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[fileModel]',
  standalone: true,
})
export class FileModelDirective {
  @Output() fileChange = new EventEmitter<File | null>();

  @HostListener('change', ['$event'])
  onChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.fileChange.emit(input.files?.[0] ?? null);
  }
}
